import React, { Component, Fragment } from 'react';
import { YMaps, Map, Placemark, GeolocationControl, FullscreenControl, ZoomControl, RulerControl, Clusterer, } from 'react-yandex-maps';
import { translate } from 'react-i18next';
import InputMask from 'react-input-mask';
import { Link, NavLink } from 'react-router-dom';
import { request, url } from '../../../config';
import markerBoldIcon from '../img/marker_bold_icon.svg';
import AlertPopup from '../../../copms/AlertPopup/AlertPopup';
import FeedbackModal from '../../../copms/Modal/FeedbackModal';
import { Autocomplete, InputAdornment, TextField } from '@mui/material';
import lastOperationsIcon from '../img/last-operations-icon.png';
import { getFormatedDate } from '../../../helpers/fotmatDate';

class Feedbacks extends Component {

    state = {
        open: false,
        fullname: "",
        email: "",
        message: "",
        currentPage: 1,
        lastPage: 1,
        list: []
    }

    getSuggestionsByCustId = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getSuggestionsByCustIdRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            pageNumber: this.state.currentPage
        }
        fetch(url("suggestion/suggestions/getSuggestionsByCustId", getSuggestionsByCustIdRequestBody))
            .then(res => res.text())
            .then((getSuggestionsByCustIdResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getSuggestionsByCustIdResponse = JSON.parse(getSuggestionsByCustIdResponseJSON);
                if (getSuggestionsByCustIdResponse.status.statusCode !== 1) {
                    if (getSuggestionsByCustIdResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getSuggestionsByCustIdResponse.status.statusCode));
                        // this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                // else {
                    this.setState({ list: getSuggestionsByCustIdResponse.model || [], lastPage: getSuggestionsByCustIdResponse.totalPages ? getSuggestionsByCustIdResponse.totalPages : 0  });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                // }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    componentDidMount() {
        this.getSuggestionsByCustId();
    }

    selectPage(e, page) {
        e.preventDefault();
        this.setState({ currentPage: page }, () => {
            this.getSuggestionsByCustId();
        });
    }

    render() {
        let { t, i18n, history } = this.props;
        let { lastPage, currentPage, openDetails, list, item } = this.state;

        return (
            <Fragment>
                <FeedbackModal open={openDetails} item={item} closeFunction={() => this.setState({ openDetails: false })} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Proposals and complaints')}</h2>
                    </div>
                </div>
                <div className="dashboard-container-main-section-vertical">
                    <div className="dashboard-transfer-list-header bg-white">
                        <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                            <NavLink exact to="/dashboard/service-network/contact" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Apply")}</NavLink>
                            <NavLink exact to="/dashboard/service-network/appeals" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Track the request")}</NavLink>
                        </div>
                    </div>
                    <div className="dashboard-contact-section">
                        {list.length == 0 ?
                            <div className="dashboard-last-operations-section-content mt-5">
                                <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                <p className="dashboard-last-operations-section-content-status">{t('You have no requests')}</p>
                            </div> : <>
                                <table className="dashboard-contact-section-table">
                                    <thead>
                                        <tr>
                                            <td>{t('date')}</td>
                                            <td>{t('Reference number')}</td>
                                            <td>{t('Its status')}</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map(item =>
                                            <tr onClick={e => this.setState({ openDetails: true, item })}>
                                                <td>{item?.dateOfShipment}</td>
                                                <td>{item?.registerNumber}</td>
                                                <td>{item?.status}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <div style={{ width: '100%', marginTop: '15px', marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                                    <ul className="dashboard-pagination">
                                        {currentPage != 1 && <li><a href="#" onClick={(e) => this.selectPage(e, currentPage - 1)}>{t('previous-page')}</a></li>}
                                        {
                                            Array.from({ length: lastPage }).map((item, index) => {
                                                if (lastPage > 3) {
                                                    if (currentPage - 1 == index + 1) {
                                                        return (
                                                            <>
                                                                {currentPage > 2 && <li><a href="#" onClick={(e) => this.selectPage(e, 1)}>1</a></li>}
                                                                {currentPage > 3 && <li><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}
                                                                <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                            </>
                                                        )
                                                    }
                                                    if (currentPage == index + 1) {
                                                        return (
                                                            <>
                                                                <li className="active" ><a href="#" style={{ cursor: 'default' }} onClick={e => e.preventDefault()}>{index + 1}</a></li>
                                                            </>
                                                        )
                                                    }
                                                    if (currentPage + 1 == index + 1) {
                                                        return (
                                                            <>
                                                                <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                                {currentPage < lastPage - 2 && <li ><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}

                                                                {currentPage + 1 < lastPage && <li ><a href="#" onClick={(e) => this.selectPage(e, lastPage)}>{lastPage}</a></li>}
                                                            </>
                                                        )
                                                    }
                                                } else {
                                                    return (
                                                        <li className={index + 1 == currentPage ? "active" : ""}><a href="#" style={lastPage == 1 ? { borderRadius: '5px' } : {}} onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                    )
                                                }
                                            })
                                        }
                                        {currentPage != lastPage && lastPage > 1 && <li><a href="#" onClick={(e) => this.selectPage(e, currentPage + 1)}>{t('next-page')}</a></li>}
                                    </ul>
                                </div>
                            </>}
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default translate("translation")(Feedbacks);
